import React from "react";
import { MapPin, Quote, Star } from "lucide-react";
import { Card, CardContent } from "./Card";
import { testimonials } from "../data/content";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
type TestimonialsProps = {
  expanded?: boolean;
};
const avatarColors = ["bg-[#E3262E] shadow-[0_8px_24px_rgba(227,38,46,0.25)]", "bg-[#0B3563] shadow-[0_8px_24px_rgba(11,53,99,0.35)]", "bg-[#A96A16] shadow-[0_8px_24px_rgba(169,106,22,0.25)]"];
export function Testimonials({
  expanded = false
}: TestimonialsProps) {
  return <Reveal className={`px-5 sm:px-8 lg:px-12 ${expanded ? "bg-[#0D1424] py-20" : "bg-[#080B14] pb-20 pt-12"}`} data-id="element-220" data-mp="2x0tfedgdoclq">
      <div className="mx-auto max-w-[1180px]" data-id="element-221" data-mp="2s1yp6qg2zlrl">
        {expanded && <SectionHeading eyebrow="Experiencias reales" title="Profes que dejaron de improvisar" subtitle="Tres compradores reales que recuperaron tiempo y mejoraron la calidad de sus clases." data-id="element-222" data-mp="2s42zbq4kph0b" />}
        <div className="grid gap-4 lg:grid-cols-3" data-id="element-223" data-mp="h4wuw2gayci7">
          {testimonials.map((item, index) => {
          const initials = item.name.split(" ").map(part => part.charAt(0)).join("").replace(".", "").slice(0, 2).toUpperCase();
          return <Card key={item.name} className="group relative overflow-hidden border-[#0B3563] bg-[#0A1A33] text-white shadow-[0_18px_55px_rgba(0,0,0,0.3)] transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-[#F5B83D]/35 hover:shadow-[0_24px_65px_rgba(0,0,0,0.4)]" data-id="element-224" data-mp="c8ol74kvjbif" data-mpi={index}>
                <div className="absolute inset-x-0 top-0 h-px bg-[linear-gradient(90deg,transparent,#F5B83D,transparent)] opacity-60" data-id="element-225" data-mp="v4ep4xcdahyy" />
                <CardContent className="flex h-full min-h-[330px] flex-col p-6 sm:p-7" data-id="element-226" data-mp="1it7do8qntnjj">
                  <div className="flex items-start justify-between gap-4" data-id="element-227" data-mp="1nnblsvbnw1m7">
                    <div className="flex gap-1 text-[#F5B83D]" aria-label="5 de 5 estrellas" data-id="element-228" data-mp="1xgpm9i7cf2b8">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className="size-[18px] fill-current" aria-hidden="true" data-id="element-229" data-mp="1ohau8ebj2jom" />)}
                    </div>
                    <Quote className="size-10 stroke-[1.5] text-[#C7CED8]" aria-hidden="true" data-id="element-230" data-mp="1jhg5agbbc467" />
                  </div>

                  <blockquote className="mt-5 flex-1 text-[15px] italic leading-7 text-[#F7F4EC] sm:text-base" data-id="element-231" data-mp="1ekfz85egr1f3">
                    “{item.quote}”
                  </blockquote>

                  <div className="mt-6 flex items-center gap-4 border-t border-white/[0.08] pt-5" data-id="element-232" data-mp="14u4vaius4s87">
                    <div className={`flex size-12 shrink-0 items-center justify-center rounded-full text-base font-black text-white ${avatarColors[index]}`} aria-hidden="true" data-id="element-233" data-mp="10t1hs307f8a5">
                      {initials}
                    </div>
                    <div className="min-w-0" data-id="element-234" data-mp="qvwqxpveyon0">
                      <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-235" data-mp="32fujpk7fadi1">
                        <p className="font-black text-white" data-id="element-236" data-mp="37fh4qfthsy1e">{item.name}</p>
                        <span className="text-[#E3262E]" aria-hidden="true" data-id="element-237" data-mp="3cf3j4sl24kbs">•</span>
                        <p className="flex items-center gap-1 text-sm text-[#AAB7C8]" data-id="element-238" data-mp="3cd8ylfdp6u88">
                          <MapPin className="size-3.5 shrink-0 text-[#E3262E]" aria-hidden="true" data-id="element-239" data-mp="3geks3vzozzlp" />
                          {item.location}
                        </p>
                      </div>
                      <p className="mt-2 text-[10px] font-black uppercase leading-4 tracking-[0.1em] text-[#F5B83D]" data-id="element-240" data-mp="2opr256jhn7yx">{item.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </Reveal>;
}